module.exports = __webpack_public_path__ + "img/crecer-stream.bcf2b68c.png";